import { loadingActionTypes } from "./loading.types";

const initialState = {
  isLoading: false
};

const loadingReducer = (state = initialState, action) => {
  switch (action.type) {
    case loadingActionTypes.SET_LOADING:
      return {
        ...state,
        isLoading: true
      };
    case loadingActionTypes.SET_NOT_LOADING:
      return {
        ...state,
        isLoading: false
      };
    default:
      return state;
  }
};

export default loadingReducer;
